import { Divider, IconButton, Stack } from "@mui/material";
import { Fragment, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

const mainLanguages = [
  {
    alt: "Croatian",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/HR.svg",
    lang: "hr",
    title: "Croatian",
  },
  {
    alt: "English",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg",
    lang: "en",
    title: "English",
  },
  {
    alt: "Serbian",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/RS.svg",
    lang: "sr",
    title: "Serbian",
  },
  {
    alt: "Slovenian",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/SI.svg",
    lang: "sl",
    title: "Slovenian",
  },
];

const expandedLanguages = [
  ...mainLanguages,
  {
    alt: "German",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg",
    lang: "de",
    title: "Deutsch",
  },
];

export default function LanguageSwitcher({
  defaultLanguage,
  showExpanded = true,
  testIdPrefix,
}) {
  const { i18n } = useTranslation();
  const localLang = localStorage.getItem("lang");
  const [lang, setLang] = useState(
    defaultLanguage ? defaultLanguage : localLang ? localLang : i18n.language,
  );

  const filter = {
    filter: "grayscale(100%)",
    opacity: 0.5,
  };

  function changeLanguage(newLang) {
    if (newLang) {
      i18n.changeLanguage(newLang);
      localStorage.setItem("lang", newLang);
      sessionStorage.setItem("lang", newLang);
      setLang(newLang);
    }
  }

  return (
    <LanguageFlagButtons
      currentLang={lang}
      filterStyle={filter}
      changeHandler={changeLanguage}
      showExpanded={showExpanded}
      testIdPrefix={testIdPrefix}
    />
  );
}

export function ChangeLangMaster({ defaultLanguage = "en", testIdPrefix }) {
  const { control, setValue } = useFormContext();
  const lang = useWatch({ control, name: "language" }) || defaultLanguage;

  const changeLanguage = (newLang) => {
    setValue("language", newLang);
  };
  return (
    <LanguageFlagButtons
      currentLang={lang}
      changeHandler={changeLanguage}
      testIdPrefix={testIdPrefix}
    />
  );
}

function LanguageFlagButtons({
  currentLang,
  changeHandler,
  showExpanded = true,
  testIdPrefix,
}) {
  const languages = showExpanded ? expandedLanguages : mainLanguages;

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      {languages.map((language, index) => (
        <Fragment key={language.lang}>
          <FlagIconButton
            language={language}
            changeHandler={changeHandler}
            currentLang={currentLang}
            testId={testIdPrefix && `${testIdPrefix}.${language.lang}`}
          />
          {index !== languages.length - 1 && (
            <Divider orientation="vertical" variant="middle" flexItem />
          )}
        </Fragment>
      ))}
    </Stack>
  );
}

function FlagIconButton({ language, changeHandler, currentLang, testId }) {
  const isActive = currentLang === language.lang;
  const { t } = useTranslation();
  return (
    <IconButton
      onClick={() => changeHandler(language.lang)}
      title={t(language.title)}
      data-testid={testId}
    >
      <img
        alt={language.alt}
        src={language.src}
        width={32}
        height={24}
        style={{
          borderRadius: 1,
          filter: isActive ? "none" : "grayscale(0.75)",
          opacity: isActive ? 1 : 0.7,
        }}
      />
    </IconButton>
  );
}
